// extracted by mini-css-extract-plugin
module.exports = {"stream":"LiveShopping_stream__3wtfr"};